import React from 'react';
import PropTypes from 'prop-types';

/**
 * Displays a table of SC module checkpoints.
 *
 * @param {Array} modules - Array of module objects { module, score, timestamp }.
 */
const ScCheckpointTable = ({ modules }) => {
    return (
        <div
            style={{
                alignContent: 'center',
                padding: '10px',
                justifyContent: 'center'
            }}>
            {modules && modules.length > 0 && (
                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: '0.8rem'
                    }}>
                    <thead>
                        <tr
                            style={{
                                backgroundColor: '#e6f0ff',
                                textAlign: 'left',
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                                borderBottom: '2px solid #ccc'
                            }}>
                            <th style={{ padding: '.5em' }}>Module</th>
                            <th style={{ padding: '.5em' }}>Score</th>
                            <th style={{ padding: '.5em' }}>Timestamp</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modules.map((m, idx) => (
                            <tr
                                key={m.module + idx}
                                style={{
                                    borderBottom: '1px solid #eee'
                                }}>
                                <td style={{ padding: '.4em', color: '#333' }}>
                                    {m.module}
                                </td>
                                <td style={{ padding: '.4em', color: '#333' }}>
                                    {m.score || 'N/A'}
                                </td>
                                <td style={{ padding: '.4em', color: '#333' }}>
                                    {m.timestamp || '—'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

ScCheckpointTable.propTypes = {
    modules: PropTypes.arrayOf(
        PropTypes.shape({
            module: PropTypes.string.isRequired,
            score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            timestamp: PropTypes.string
        })
    ).isRequired
};

export default ScCheckpointTable;
